import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import FilterTogglebar from "../TechnicalView/FilterTogglebar";
import PublicView from "./PublicView";
import PublicViewResponsive from "./PublicViewResponsive";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import userActions from "../TechnicalView/actions";

const PublicViewContainer = () => {
  const { isMobile } = useGetViewPortDimensions();
  const {
    loadIrrigationDistricts,
    loadAgricultureDistrictWater,
    loadWaterDeliveries,
    loadCityMetrics,
    loadCities,
    loadCityWaterSources,
    loadEntityEntitlements,
    loadTribes,
    loadTribeMetrics,
    setIsTribe,
    setEntitlementYear,
    loadEntitlementsByYear,
    loadAccessDifferenceRange,
    loadCitiesWaterUse,
    // setChart,
    // resetSelectedCity,
    // toggleAboutDrawer,
    loadCityMetricsGauge,
  } = userActions();

  const componentMount = () => {
    console.log("Here--------------------->");
    loadIrrigationDistricts();
    loadAgricultureDistrictWater();
    loadWaterDeliveries();
    loadCityMetrics(1); //as default, we will show the information for the first item in the dropdown menu
    loadCityWaterSources(1);
    loadEntityEntitlements(1);
    loadCities();
    loadTribes();
    loadTribeMetrics(43);
    setIsTribe(false);
    setEntitlementYear(2022);
    loadEntitlementsByYear(2022);
    loadAccessDifferenceRange(2022);
    loadCitiesWaterUse();
    loadCityMetricsGauge(1);
  }
  useEffect(componentMount, []);

  return (
    <Grid container>
      {!isMobile ? <FilterTogglebar /> : null}
      {!isMobile ? <PublicView /> : <PublicViewResponsive />}
    </Grid>
  );
};

export default PublicViewContainer;
